import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import './LoadingScreen.css';

const LoadingScreen = (props) => {
    const { text = 'Cargando...', className = '' } = props;

    return (
        <div className={`loadingScreen ${className}`.trim()}>
            <div className="loadingScreenCard">
                <div className="spinner-border text-primary loadingScreenSpinner" role="status" aria-hidden="true"></div>
                <p className="loadingScreenText">{text}</p>
            </div>
        </div>
    );
}

export default LoadingScreen;
